import { Link, Avatar, ListItemText, SxProps, Theme } from '@mui/material';
import ShortenCode from '../shorten-code/ShortenCode';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

type OwnProps = {
  name: string;
  subText?: string;
  dataTestId?: string;
  to?: string;
  secondarySx?: SxProps<Theme>;
};

const UserAvatar = ({ name, subText, dataTestId, to, secondarySx = {} }: OwnProps) => {
  const router = useRouter();

  const textDecoration = to ? 'underline' : 'none';

  return (
    <>
      <Avatar alt={name} srcSet="N/A" />

      <ListItemText
        disableTypography
        primary={
          <ShortenCode value={name} maxLength={20} typography="body2" dataTestId={dataTestId} />
        }
        secondary={
          <Link
            data-test-id="sub-text-link"
            {...(to ? { href: paths.dashboard.customerProfile(to) } : {})}
            onClick={(e) => {
              if (to) {
                e.preventDefault(); // We prevent the default behaviour in order to skip hard-refreshing the page

                router.push(paths.dashboard.customerProfile(to || ''));
              }
            }}
            variant="body2"
            sx={{
              cursor: to ? 'pointer' : 'auto',
              color: '#737A80',
              textDecoration,
              '&:hover': {
                color: to ? '#4D545B' : 'text.disabled',
                textDecoration,
              },
              ...secondarySx,
            }}
          >
            {subText}
          </Link>
        }
      />
    </>
  );
};

export default UserAvatar;
